import React from 'react';
import { BrowserRouter as Router, Route, Redirect, withRouter  } from 'react-router-dom';
import { LoginPage } from '../LoginPage/LoginPage';
import CompliancePopup from '../components/CompliancePopup';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import PropTypes from 'prop-types';
import Dashboard from '../components/DashboardPage';
import $ from 'jquery';
import { userService } from '../_services';
import { analyticsGranted, marketingGranted } from '../cookie-consent/cookie-consent.config';
var _hsq = window._hsq = window._hsq || [];

class HomePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            AnalyticList: [],
            userdata: JSON.parse(localStorage.getItem('user')),
            CompliancePopup: true
        }
        localStorage.setItem('Prev_Filter_Status', '-');
        localStorage.setItem('Updated_Filter_Status', '-');
        localStorage.setItem('Page_Path', '/dashboard');
    }

    componentDidMount() {
        //if (localStorage.getItem('analytics_data') == '' || localStorage.getItem('analytics_data') == null || localStorage.getItem('analytics_data') == undefined || localStorage.getItem('analytics_data') == "{}") {
        //    if (this.state.AnalyticData == undefined || 'this.state.AnalyticData == undefined') {
        //        this.checkAnalytics(this.state.userdata["wholesaler_Id"].toString(), this.state.userdata["paramsname"]);
        //    }
        //}
        setTimeout(() => {
            if (this.props.history) {
                this.sendPageView(this.props.history.location);
                this.props.history.listen(this.sendPageView);
            }
        }, 1200);
    }

    sendPageView(location) {
        switch (window.location.pathname) {
            case '/filter':
                document.title = 'Filter';
                break;
            case '/filter/':
                document.title = 'Filter';
                break;
            case '/admin/report':
                document.title = 'Reports';
                break;
            case '/admin/report/':
                document.title = 'Reports';
                break;
            case '/wholesaler/report':
                document.title = 'Reports';
                break;
            case '/wholesaler/report/':
                document.title = 'Reports';
                break;
            case '/admin/tools':
                document.title = 'Tools';
                break;
            case '/admin/tools/':
                document.title = 'Tools';
                break;
            case '/wholesaler/tools':
                document.title = 'Tools';
                break;
            case '/wholesaler/tools/':
                document.title = 'Tools';
                break;
            case '/wholesaler/payment':
                document.title = 'Payments';
                break;
            case '/wholesaler/payment/':
                document.title = 'Payments';
                break;
            case '/distributor/tools':
                document.title = 'Tools';
                break;
            case '/distributor/tools/':
                document.title = 'Tools';
                break;
            case '/dashboard':
                document.title = 'Dashboard';
                break;
            case '/dashboard/':
                document.title = 'Dashboard';
                break;
            case '/wholesaler/analytics/signups':
                document.title = 'Signups';
                break;
            case '/wholesaler/analytics/signups/':
                document.title = 'Signups';
                break;
            case '/wholesaler/analytics/geographic':
                document.title = 'Geographic';
                break;
            case '/wholesaler/analytics/geographic/':
                document.title = 'Geographic';
                break;
            case '/wholesaler/analytics/pharmacies':
                document.title = 'Pharmacies';
                break;
            case '/wholesaler/analytics/pharmacies/':
                document.title = 'Pharmacies';
                break;
            case '/admin/analytics/signups':
                document.title = 'Signups';
                break;
            case '/admin/analytics/signups/':
                document.title = 'Signups';
                break;
            case '/admin/analytics/geographic':
                document.title = 'Geographic';
                break;
            case '/admin/analytics/geographic/':
                document.title = 'Geographic';
                break;
            case '/admin/analytics/pharmacies':
                document.title = 'Pharmacies';
                break;
            case '/admin/analytics/pharmacies/':
                document.title = 'Pharmacies';
                break;
            case '/admin/analytics/publicapi':
                document.title = 'Public API';
                break;
            case '/admin/analytics/publicapi/':
                document.title = 'Public API';
                break;
            case '/login':
                document.title = 'Dashboard Login';
                break;
            case '/':
                document.title = 'Reporting Dashboard';
                break;
            case '/login/':
                document.title = 'Dashboard Login';
                break;
            case '/resetPassword/':
                document.title = 'Reset Password Page';
                break;
            case '/admin/companyOverview/':
                document.title = 'Company Overview';
                break;
            case '/admin/companyOverview':
                document.title = 'Company Overview';
                break;
            default:
                document.title = 'Page Not Found';
                break;
        }
        if (analyticsGranted()) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: location.pathname
            });
        }
        if (marketingGranted()) {
            var hubspotQueue = window._hsq = window._hsq || [];
            hubspotQueue.push(['setPath', location.pathname]);
            hubspotQueue.push(['trackPageView']);
        }
    }
    checkAnalytics(whid, whname) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ whid, whname })
            };
            return fetch(`/api/Analytic/GetAnalytic`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        localStorage.setItem('analytics_data', JSON.stringify(apidata));
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    compliancePopup = e => {
        this.setState({
            CompliancePopup: !this.state.CompliancePopup
        });
        $('body').toggleClass('hide-scroll');
    }
    render() {
        try {
            if (this.state.userdata.iscompopup == false && this.state.userdata.userrole == 'Wholesaler') {
                $('body').addClass('hide-scroll');
            } else {
                $('body').removeClass('hide-scroll');
            }
        } catch (error) { }
        try {
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
        } catch (error) { }
        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            <Route path="/login" component={LoginPage} />
        }
        else {
            return (
                <div className="newBoard">
                    <Header />
                    <Sidebar />
                    <Dashboard />
                    {
                        this.state.userdata.iscompopup == false && this.state.userdata.userrole == 'Wholesaler' ?
                            <div>
                                {
                                    this.state.CompliancePopup ?
                                        <CompliancePopup text={'Compliance FAQs'} sub={'Frequently Asked Questions on Glic Health Compliance. Please read through and acknowledge.'} closePopup={this.compliancePopup.bind(this)} /> : null
                                }
                            </div>
                            : null
                    }
                </div>
            );
        }
    }
}
export default withRouter(HomePage);
export { HomePage };